import React from "react";
import ProductCard from "./ProductCard";

const TrendingProducts = ({ products, addToCart, addedItems, categories }) => {
  return (
    <section className="container my-5">
      <div className="titel_product text-center">
        <h1>Trending product</h1>
        <div className="product_hr_box d-flex justify-content-center">
          <hr className="product_hr" style={{ width: "80px", borderTop: "3px solid #000" }} />
        </div>
      </div>

      <div className="row mt-4">
        {products && products.length > 0 ? (
          products.slice(0, 4).map((item) => (
            <div key={item.id} className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4 ">
              <ProductCard
                item={item}
                categories={categories}
                addToCart={addToCart}
                isAdded={addedItems.includes(item.id)}
              />
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p>No products available</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default TrendingProducts;
